/**
 * @generated SignedSource<<4515d018a6f2f5c6bb0811109361e327>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UsersAllRolesQuery$variables = Record<PropertyKey, never>;
export type UsersAllRolesQuery$data = {
  readonly allRoles: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly name: string | null | undefined;
      readonly summary: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type UsersAllRolesQuery = {
  response: UsersAllRolesQuery$data;
  variables: UsersAllRolesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RoleNodeConnection",
    "kind": "LinkedField",
    "name": "allRoles",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RoleNode",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "summary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UsersAllRolesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UsersAllRolesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b232ebd81a969642a4a1fe3d98f275a2",
    "id": null,
    "metadata": {},
    "name": "UsersAllRolesQuery",
    "operationKind": "query",
    "text": "query UsersAllRolesQuery {\n  allRoles {\n    nodes {\n      id\n      name\n      summary\n      isActive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3e605da2f60a22fbc65b3497246c854";

export default node;
